<script>
    import model from '../../stores/modelStore';
	import { projectSettings } from "../../config";
	import registrationTypes from "../../config/registrationTypes";
	import { isValid } from "../../validation";

	import Form from "../../components/Form.svelte";
    import DisplayRow from "../../components/DisplayRow.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
    import TextDisplay from "../../components/TextDisplay.svelte";
	import DatePicker from "../../components/DatePicker.svelte";
	import Claimant from "../../components/Claimant.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import AddressAutoComplete from "../../components/AddressAutoComplete.svelte";

	import MedicareNumber from "./components/MedicareNumber.svelte";

	export let disabled = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let buttons = null;
	let isMedicareValid = true;
	let originalContactAddress = $model.contact.address.formattedAddress;
	let originalClaimantAddress = $model.claimant?.address?.formattedAddress;

    if (!$model.contact.initialised) {
        $model.contact.initialised = true;
	    $model.contact.allowDoBUpdate = !$model.contact.dateOfBirth
    }

    const handleSubmit = async (e) => {
    	buttons.blockNext();

		let errors = isValid();

		if (!errors.length && isMedicareValid) {
			$model.contactAddressModified = originalContactAddress != $model.contact.address.formattedAddress;
			$model.claimantAddressModified = originalClaimantAddress != $model.claimant?.address?.formattedAddress;

			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError)
			} else {
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
    };

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const initialise = () => {};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="form-personal-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Please provide your Contact details</h1>
			</FormColumn>
		</FormRow>
	
		<hr class="primary" />

		<div class="confirmation-box-shadow">

			<DisplayRow>
				<FormColumn>
					<TextDisplay label="Who are you registering for?" value={registrationTypes.options.filter(t => t.value === $model.registrationType)[0].name} />
				</FormColumn>
			</DisplayRow>

			<DisplayRow style="margin-top: 36px">
				<FormColumn cols="6">
					<TextDisplay label="First name" value="{$model.contact.firstName}" />
				</FormColumn>
				<FormColumn cols="6">
					<TextDisplay label="Surname" value="{$model.contact.surname}" />
				</FormColumn>
			</DisplayRow>

			<DisplayRow>
				<FormColumn cols="6">
					<TextDisplay label="Email address" value="{$model.contact.emailAddress}" />
				</FormColumn>
				<FormColumn cols="6">
					<TextDisplay label="Phone number" value="{$model.contact.phoneNumber}" />
				</FormColumn>
			</DisplayRow>

			{#if $model.contact.allowDoBUpdate && !disabled}

				<FormRow>
					<FormColumn cols="6">
						<DatePicker
							required
							disabled={disabled}
							id="e_dateOfBirth"
							label="Date of birth"
							validator={true}
							start={new Date(1924, 0, 1)}
							end={new Date()}
							placeholder="e.g. 01/05/1987"
							bind:formattedSelected={$model.contact.dateOfBirth}
							openOnClass="calendar-icon" />
					</FormColumn>
					<FormColumn cols="6">
					</FormColumn>
				</FormRow>

			{:else}

				<DisplayRow>
					<FormColumn cols="6">
						<TextDisplay label="Date of birth" value="{$model.contact.dateOfBirth}" />
					</FormColumn>
					<FormColumn cols="6">
					</FormColumn>
				</DisplayRow>

			{/if}

			{#if !disabled}

				<AddressAutoComplete idPrefix="c"
					bind:manualEntry={$model.contact.address.manualEntry}
					bind:googlePlaceJson={$model.contact.address.googlePlaceJson}
					bind:formattedAddress={$model.contact.address.formattedAddress}
					bind:premise={$model.contact.address.premise}
					bind:subpremise={$model.contact.address.subpremise}
					bind:street={$model.contact.address.street}
					bind:suburb={$model.contact.address.suburb}
					bind:state={$model.contact.address.state}
					bind:postcode={$model.contact.address.postcode}
					bind:country={$model.contact.address.country}
					bind:lat={$model.contact.address.lat}
					bind:lng={$model.contact.address.lng}
					bind:placeId={$model.contact.address.placeId}
					bind:url={$model.contact.address.googleMapsUrl}
					required>
				</AddressAutoComplete>

			{:else}

				<DisplayRow>
					<FormColumn>
						<TextDisplay label="Address" value="{$model.contact.address.formattedAddress}" />
					</FormColumn>
				</DisplayRow>

			{/if}

			{#if $model.registrationType && $model.registrationType != registrationTypes.types.Myself.value}
				<div class="confirmation-box-shadow">
					<div class="claimant-details">
						<Claimant {disabled}
							registrationType={$model.registrationType}
							bind:groupMemberInformation={$model.groupMemberInformation}
							bind:claimant={$model.claimant} />
					</div>
				</div>
			{/if}

			<MedicareNumber {disabled}
				bind:isValid={isMedicareValid}
				bind:medicareNumber={$model.groupMemberInformation.medicareNumber}
				bind:medicareRef={$model.groupMemberInformation.medicareRef} />
	
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>

</PageSection>

<style>

	.claimant-details {
		margin-bottom: 20px;
	}

</style>
